import { useAbsenden } from './GuideAbsendeRegister';
import { artWort } from './guide-absenden';

/** Der EINE Knopf samt Zusammenfassung davor und den Teilen, die unterwegs sind oder nicht ankamen (Phase 2 der Guide-Flaeche; Logik: guide-absenden.ts). */
export function AbsendenKnopf({ titel }: { titel: string }) {
  const a = useAbsenden();
  if (!a) return null;
  const z = a.zustand;
  const kurzTitel = titel.length > 44 ? `${titel.slice(0, 43)}…` : titel;
  const satz = z.satz;
  const farbe = z.art === 'teilfehler' ? 'var(--tn-red, #f7768e)' : 'var(--tn-accent,var(--tn-link))';
  return (
    <div data-ai-id="guide-absenden" data-zustand={z.art} style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
      {z.zusammenfassung.length > 0 && (
        <div data-ai-id="guide-absenden-zusammenfassung" style={{ border: '1px solid var(--tn-accent,var(--tn-link))', borderRadius: 7, padding: '6px 9px', fontSize: 11.5, lineHeight: 1.4, background: 'color-mix(in srgb, var(--tn-accent,var(--tn-link)) 9%, transparent)' }}>
          <b>Das geht an den Berater von „{kurzTitel}“:</b>
          {z.zusammenfassung.map((s, i) => <div key={i}>{s}</div>)}
          <div style={{ color: 'var(--tn-text-muted)', fontSize: 11 }}>Enter in einem dieser Felder sendet alles zusammen.</div>
        </div>
      )}
      {z.unterwegs.length > 0 && z.offen.length > 0 && (
        <div data-ai-id="guide-absenden-teilweise" role="status" style={{ fontSize: 11.5 }}>
          <b>Schon eingereiht:</b> {z.unterwegs.map(j => artWort(j.art)).join(' + ')} · <b>noch nicht eingereiht:</b> {z.offen.map(t => artWort(t.art)).join(' + ')} — der Knopf bietet nur den fehlenden Teil an.
        </div>
      )}
      {z.unterwegs.length > 0 && (
        <div data-ai-id="guide-absenden-unterwegs" role="status" style={{ fontSize: 11.5, color: 'var(--tn-text-muted)' }}>
          ⟳ {z.unterwegs.map(j => artWort(j.art)).join(' + ')} wird gesendet — lokal gesichert, nichts geht verloren.
        </div>
      )}
      {z.fehler.length > 0 && (
        <div data-ai-id="guide-absenden-fehler" role="alert" style={{ border: '1px solid var(--tn-red, #f7768e)', borderRadius: 7, padding: '6px 9px', fontSize: 11.5, lineHeight: 1.4, background: 'rgba(247,118,142,0.08)' }}>
          {z.fehler.map(j => (
            <div key={j.id} data-ai-id={`guide-absenden-fehler-${j.id}`}>
              <b>✗ {artWort(j.art)} nicht angekommen.</b>{j.error ? ` ${j.error}` : ''}
              {j.state === 'blocked' && (
                <button type="button" data-ai-id={`guide-absenden-entwurf-${j.id}`} onClick={() => a.zurueckInEntwurf(j.id)}
                  style={{ marginLeft: 8, fontSize: 11, padding: '1px 8px', borderRadius: 5, cursor: 'pointer', background: 'var(--tn-bg)', color: 'var(--tn-text)', border: '1px solid var(--tn-border)' }}>Zurück in den Entwurf</button>
              )}
            </div>
          ))}
          <div style={{ color: 'var(--tn-text-muted)' }}>Dein Text bleibt im Feld. Der Teil, der schon angekommen ist, wird nicht noch einmal gesendet.</div>
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
        <span aria-live="polite" style={{ flex: '1 1 200px', minWidth: 0, fontSize: 11.5, color: 'var(--tn-text-muted)' }}>{satz}</span>
        <button type="button" data-ai-id="guide-absenden-senden" disabled={!z.klickbar} onClick={a.sendeAlles}
          style={{ padding: '8px 14px', borderRadius: 7, fontSize: 12.5, fontWeight: 650, cursor: z.klickbar ? 'pointer' : 'default',
            background: z.klickbar ? farbe : 'var(--tn-bg)', color: z.klickbar ? 'var(--tn-tief, #1a1b26)' : 'var(--tn-text-muted)', border: `1px solid ${farbe}`, opacity: z.art === 'sendet' ? 0.7 : 1 }}>
          {z.label}{z.klickbar ? ' ⏎' : ''}
        </button>
      </div>
    </div>
  );
}
